import type { ReactNode } from 'react';

export enum ContainerLayout {
  /** Two equal columns (50/50) from lgMin (1200px). Stacked below. */
  Equal = 'EQUAL',
  /** Two equal columns (50/50) from lgMin (1200px) until the first reaches 750px, then 750px + flexible second. Stacked below lgMin. */
  EqualWide = 'EQUAL_WIDE',
  /** Fixed sidebar on the left (300px, 750px from 2561px) + flexible main column. Side-by-side at all widths. */
  SidebarLeft = 'SIDEBAR_LEFT',
  /** Flexible main column + fixed 300px sidebar on the right. Same at all breakpoints. */
  SidebarRight = 'SIDEBAR_RIGHT',
}

type ContainerSharedProps = {
  /**
   * When `true`, the container spans the full viewport width.
   * When `false` or omitted, max-width is 1568px and the container is centered horizontally.
   */
  fluid?: boolean;
  className?: string;
  /** Rendered as data-testid on the root div. */
  dataTestId?: string;
  /**
   * When `true`, the container has a bottom margin of 24px.
   */
  spacer?: boolean;
};

export type ContainerPropsWithoutLayout = ContainerSharedProps & {
  layout?: never;
  children?: ReactNode;
};

export type ContainerPropsWithLayout = ContainerSharedProps & {
  /**
   * Enables a responsive two-column CSS grid. Expects exactly two children.
   * Column gap is 8px below smMin (768px) and 24px from smMin upward.
   * @see {@link ContainerLayout}
   */
  layout: ContainerLayout;
  children?: [ReactNode, ReactNode];
};

export type ContainerProps = ContainerPropsWithoutLayout | ContainerPropsWithLayout;
